export const ERROR_RED = '#ff0033';
export const WARNING_YELLOW = '#eed202';
export const SUCCESS_GREEN = '#84de02';
export const INFO_GREY = '#99acba';
